import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faFire } from '@fortawesome/free-solid-svg-icons';

const MAX_WATCHES = 20;

/** Summary bar: số đang theo dõi / số đã giảm giá */
function PriceWatchSummaryBar({ watches }) {
    const dropsCount = watches.filter((w) => w.lastKnownPrice < w.initialPrice).length;

    return (
        <div className="flex bg-surface rounded-xl border border-line shadow-sm mx-3 mt-3">
            <div className="flex-1 flex flex-col items-center py-3 gap-0.5">
                <div className="flex items-center gap-1.5">
                    <FontAwesomeIcon icon={faChartLine} className="text-primary-500 text-xs" />
                    <span className="text-base font-bold text-primary-500">{watches.length}/{MAX_WATCHES}</span>
                </div>
                <span className="text-xs text-content-3">Đang theo dõi</span>
            </div>
            <div className="w-px bg-surface-muted my-3" />
            <div className="flex-1 flex flex-col items-center py-3 gap-0.5">
                <div className="flex items-center gap-1.5">
                    <FontAwesomeIcon icon={faFire} className="text-green-500 text-xs" />
                    <span className="text-base font-bold text-green-500">{dropsCount}</span>
                </div>
                <span className="text-xs text-content-3">Đã giảm giá</span>
            </div>
        </div>
    );
}

export default PriceWatchSummaryBar;
